import {FEATURE_FLAGS} from '@packages/systems/feature-config/shared';
import {defineAbilityConfig} from '../system/defineAbilityConfig';

export const canAccessFeatureConfigDashboard = defineAbilityConfig({
  featureFlags: {[FEATURE_FLAGS.FEATURE_CONFIG_DASHBOARD]: true},
} as const);
